import React from 'react'
import { Input } from 'antd'

const { TextArea } = Input

export const CustomTextArea = ({ style, ...props }) => {
  return (
    <TextArea
      style={{
        fontSize: '12px',
        ...style
      }}
      {...props}
    />
  )
}